import { useQuery } from '@tanstack/react-query'
import { getW2WorkStatusSummary, W2WorkStatusSummaryItem } from 'api/w2/status'
import { w2Keys } from './keys'

export const useW2WorkStatusSummary = () =>
  useQuery<W2WorkStatusSummaryItem[]>({
    queryKey: w2Keys.workStatusSummary,
    queryFn: getW2WorkStatusSummary,
  })
